export function getCookie(key: string) {
	if (!key) {
		return null;
	}

	return (
		decodeURIComponent(
			document.cookie.replace(
				new RegExp(
					`(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(
						/[\-\.\+\*]/g,
						'\\$&'
					)}\\s*\\=\\s*([^;]*).*$)|^.*$`
				),
				'$1'
			)
		) || null
	);
}
